import Vue from "vue";
import titleMixin from "@/mixins/title";
export default Vue.extend({
    mixins: [titleMixin],
    data() {
        return {
            title: this.$t("serviceCategories.create.title"),
            data: {
                name: "",
                description: undefined,
                order: 0
            },
            validationOptions: {
                rules: {
                    name: {
                        required: true,
                        rangeLength: [3, 50]
                    },
                    description: {
                        maxLength: 255,
                    }
                }
            }
        };
    },
    methods: {
        create() {
            return this.$store.dispatch("serviceCategory/create", {
                serviceCategory: this.data
            });
        },
        createSuccess() {
            this.$toast.showSuccessToast(this.$t("serviceCategories.create.toastSuccessTitle"), this.$t("serviceCategories.create.toastSuccessContent", {
                name: this.data.name
            }));
            return this.$router.push("/administration/service-categories");
        },
        cancel() {
            return this.$router.push("/administration/service-categories");
        }
    }
});
